<template>
  <div class="customer-select" :class="{ 'is-auto-width': autoWidth }">
    <el-select
      v-model="selectValue"
      clearable
      :filter-method="filterMethod"
      filterable
      placeholder="请选择客户"
      popper-class="customer-select__box"
      @visible-change="handleVisibleChange"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script setup>
import { getCustomerList } from '@/api'
import { ref, computed, onMounted } from 'vue'

defineOptions({
  name: 'CustomerSelect'
})

const props = defineProps({
  value: {
    type: [Number, String],
    default: ''
  },
  autoWidth: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['update:value', 'change'])

const options = ref([])
const timeout = ref(null)

const selectValue = computed({
  get() {
    return props.value
  },
  set(newValue) {
    emits('update:value', newValue)
    emits('change', newValue)
  }
})

const filterMethod = (query, option) => {
  console.log(query, option)
  clearTimeout(timeout.value)
  timeout.value = setTimeout(() => {
    getOptions(query)
  }, 500)
}
const getOptions = (nameLike = '') => {
  getCustomerList({
    page: 1,
    pageSize: 20,
    nameLike: nameLike
  }).then((res) => {
    options.value = res.result.customerList.map((item) => {
      return {
        value: item.id,
        label: item.name
      }
    })
  })
}
const handleVisibleChange = (visible) => {
  if (!visible && selectValue.value) {
    getOptions()
  }
}

onMounted(() => {
  getOptions()
})
</script>

<style lang="scss" scoped>
.customer-select {
  :deep(.el-select) {
    width: 240px;
  }
}

.is-auto-width {
  :deep(.el-select) {
    width: unset;
  }
}
</style>

<style lang="scss">
.customer-select__box {
  max-width: 240px;
}
</style>
